import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

type Props = {
  toggleSelection: (part: string) => void;
  isSelected: (part: string) => boolean;
};

export default function BackBodyDiagramComponent({
  toggleSelection,
  isSelected,
  }: Props) {
  return (
    <Svg
      width={204}
      height={556}
      viewBox="0 0 204 556"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G
        clipPath="url(#clip0_3749_24592)"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
      >
        <Path
          d="M28.91 192.131c0-.96-1.36-41.28 1.66-58.34.01-.07.1-.07.12 0 .25.92 1.44 3.64 6.71 4.57 5.27.93 10.62.17 13.68.22 1.34 6.39 5.82 31.86 7.44 43.04-.58 4.63-3.08 14.74-4.79 15.94-3.27 2.3-8.69 2.92-12.89 2.03-7.25-1.54-11.93-7.45-11.93-7.45v-.01z"
          fill={isSelected("left_upper_arm_back") ? "#3BC3C1" : "#D8F3F3"}
          onClick={() => toggleSelection("left_upper_arm_back")}
        />
        <Path
          d="M36.91 278.931c.53-5.55 3.58-11.8 5.5-18.46 3.45-12.43 6.15-27.16 7.71-37.07 1.17-7.46 1.56-19.96 3.6-25.85 0 0-5.99 3.86-13.41 1.87-7.42-1.99-11.4-7.29-11.4-7.29 0 .97-2.14 6.83-4.2 19.51-2.06 12.68-1.66 41.19-3.24 46.66-.86 2.98-2.27 16.53-3.7 20.62h18.95l.19.01z"
          fill={isSelected("left_forearm_back") ? "#3BC3C1" : "#D8F3F3"}
          onClick={() => toggleSelection("left_forearm_back")}
        />
        <Path
          d="M17.76 278.93c-2.62 3.3-10.51 16.17-11.69 18.4-1.18 2.23-7.25 14.21-3.7 16.58 3.55 2.37 7.55-5.77 8.29-6.22.74-.45-1.04 17.92 2.81 21.47 3.85 3.55 8 2.07 10.96 1.63 2.96-.44 4.29-5.18 5.33-4.74 1.04.44 3.11-.3 3.85-2.81 8.98-18.07 3.48-38.76 3.31-44.31H17.76z"
          fill={isSelected("left_hand_back") ? "#3BC3C1" : "#D8F3F3"}
          onClick={() => toggleSelection("left_hand_back")}
        />

        <Path
          d="M31.23 135.281c2.59 3.98 17.85 6.49 33.18-2.59 21.79-12.9 14.62-19.53 37.731-22 0-5.58-.18-15.64-.18-15.64h-52.81s-6.61-.02-11.65 7.5-8.89 28.69-6.26 32.72l-.01.01z"
          fill={isSelected("left_shoulder_back") ? "#3BC3C1" : "#D8F3F3"}
          onClick={() => toggleSelection("left_shoulder_back")}
        />
        <Path
          d="M185.781 278.93c2.62 3.3 10.51 16.17 11.69 18.4 1.18 2.23 7.25 14.21 3.7 16.58-3.55 2.37-7.55-5.77-8.29-6.22-.74-.45 1.04 17.92-2.81 21.47-3.85 3.55-8 2.07-10.96 1.63-2.96-.44-4.29-5.18-5.33-4.74-1.04.44-3.11-.3-3.85-2.81-8.98-18.07-3.48-38.76-3.31-44.31h19.16z"
          fill={isSelected("right_hand_back") ? "#772EFF" : "#DECCFF"}
          onClick={() => toggleSelection("right_hand_back")}
        />

        <Path
          d="M174.631 192.131c0-.96 1.36-41.28-1.66-58.34-.01-.07-.1-.07-.12 0-.25.92-1.44 3.64-6.71 4.57-5.27.93-10.62.17-13.68.22-1.34 6.39-5.82 31.86-7.44 43.04.58 4.63 3.08 14.74 4.79 15.94 3.27 2.3 8.69 2.92 12.89 2.03 7.25-1.54 11.93-7.45 11.93-7.45v-.01z"
          fill={isSelected("right_upper_arm_back") ? "#772EFF" : "#DECCFF"}
          onClick={() => toggleSelection("right_upper_arm_back")}
        />
        <Path
          d="M166.621 278.921c-.53-5.55-3.57-11.79-5.49-18.45-3.45-12.43-6.15-27.16-7.71-37.07-1.17-7.46-1.56-19.96-3.6-25.85 0 0 5.99 3.86 13.41 1.87 7.42-1.99 11.4-7.29 11.4-7.29 0 .97 2.14 6.83 4.2 19.51 2.06 12.68 1.66 41.19 3.24 46.66.86 2.98 2.27 16.53 3.7 20.62h-19.15zM172.801 135.281c-2.59 3.98-17.85 6.49-33.18-2.59-21.79-12.9-14.62-19.53-37.73-22 0-5.58.18-15.64.18-15.64h52.81s6.61-.02 11.65 7.5 8.89 28.69 6.26 32.72l.01.01z"
          fill={isSelected("right_forearm_back") ? "#772EFF" : "#DECCFF"}
          onClick={() => toggleSelection("right_forearm_back")}
        />
        <Path
          d="M172.801 135.281c-2.59 3.98-17.85 6.49-33.18-2.59-21.79-12.9-14.62-19.53-37.73-22 0-5.58.18-15.64.18-15.64h52.81s6.61-.02 11.65 7.5 8.89 28.69 6.26 32.72l.01.01z"
          fill={isSelected("right_shoulder_back") ? "#772EFF" : "#DECCFF"}
          onClick={() => toggleSelection("right_shoulder_back")}
        />
        <Path
          d="M48.3 95.06C59.09 90.43 70 82.64 74.15 82.08c3.3-.45 7.89-7.17 7.95-10.35.06-3.18 0-13.86 0-13.86s9.69 4.1 20.021 4.1c9.76 0 19.91-4.1 19.91-4.1s-2.01 12.96-1.34 15.5c.3 1.15 2.01 5.92 7 7.06 8.9 2.03 21.63 11.41 28.45 14.69-19.06 0-86.69-.07-107.84-.07v.01z"
          fill={isSelected("neck_back") ? "#FFE000" : "#FFF9CC"}
          onClick={() => toggleSelection("neck_back")}
        />
        <Path
          d="M102.121 61.96c-11.77.86-20.57-4.21-20.57-4.21s-5.7.22-8.43-10.11c-2.94-11.15-2.02-14.04 1.27-14.97.1-5.28-2.28-32.92 27.73-31.88v61.18-.01zM102.221 61.96c11.77.86 20.57-4.21 20.57-4.21s5.7.22 8.43-10.11c2.94-11.15 2.02-14.04-1.27-14.97-.1-5.28 2.28-32.92-27.73-31.88v61.18-.01z"
          fill={isSelected("head_left_back") ? "#FFE000" : "#FFF9CC"}
          onClick={() => toggleSelection("head_left_back")}
        />
        <Path
          d="M102.221 61.96c11.77.86 20.57-4.21 20.57-4.21s5.7.22 8.43-10.11c2.94-11.15 2.02-14.04-1.27-14.97-.1-5.28 2.28-32.92-27.73-31.88v61.18-.01z"
          fill={isSelected("head_right_back") ? "#FFE000" : "#FFF9CC"}
          onClick={() => toggleSelection("head_right_back")}
        />
        <Path
          d="M102.141 110.699c-6.84.72-12.5.2-22.46 9.67-13.42 12.77-19.37 15.23-28.89 17.62 1.56 3.92 9.52 50.39 9.52 59.43 28.19-9.25 41.83-27.54 41.83-27.54v-59.18z"
          fill={isSelected("left_upper_back") ? "#4DCE36" : "#DBF5D6"}
          onClick={() => toggleSelection("left_upper_back")}
        />
        <Path
          d="M102.121 110.699c6.84.72 12.5.2 22.46 9.67 13.42 12.77 19.37 15.23 28.89 17.62-1.56 3.92-9.52 50.39-9.52 59.43-28.19-9.25-41.83-27.54-41.83-27.54v-59.18z"
          fill={isSelected("right_upper_back") ? "#4DCE36" : "#DBF5D6"}
          onClick={() => toggleSelection("right_upper_back")}
        />
        <Path
          d="M56.86 232.411s-.16-10.82 1.41-16.81c1.18-4.49 2.21-15.21 2.05-18.18-.16-2.97 21.08-3.33 41.831-27.54v74.12s-12.68-13.15-26.41-14.23c-12.78-1.01-18.88 2.65-18.88 2.65v-.01z"
          fill={isSelected("left_lower_back") ? "#4DCE36" : "#DBF5D6"}
          onClick={() => toggleSelection("left_lower_back")}
        />
        <Path
          d="M147.431 232.411s.16-10.82-1.41-16.81c-1.18-4.49-2.21-15.21-2.05-18.18.16-2.97-21.08-3.33-41.83-27.54v74.12s12.68-13.15 26.41-14.23c12.78-1.01 18.88 2.65 18.88 2.65v-.01z"
          fill={isSelected("right_lower_back") ? "#4DCE36" : "#DBF5D6"}
          onClick={() => toggleSelection("right_lower_back")}
        />
        <Path
          d="M109.761 554.18c10.28 1.28 19.72-6.54 22.85-6.85 3.13-.31 6.25-.3 8.68-1.98 2.43-1.68 7.68-2.23 7.7-4.11.03-2.11-3.03-4.36-8.7-5.32-2.65-.45-5.86-4.77-7.68-6.64-2.74-2.81-3.44-11.1-3.44-11.1h-22.5s-1.71 7.38 0 11.34-3.47 10.21-2.86 16.76c.61 6.55 5.94 7.92 5.94 7.92l.01-.02z"
          fill={isSelected("right_foot_back") ? "#F94E19" : "#FED9CD"}
          onClick={() => toggleSelection("right_foot_back")}
        />

        <Path
          d="M106.971 404.649h31.01s7.36-17.01 4.1-36.57c2.1-12.11 17.07-57.37 11.72-88.38-5.7 14.71-32.51 23.2-51.43 5 0 20.51.79 28.29 2 42.64 1.09 13 1.54 33.77.27 42.37-1.27 8.6-1.16 25.97 2.33 34.94z"
          fill={isSelected("right_thigh_back") ? "#F94E19" : "#FED9CD"}
          onClick={() => toggleSelection("right_thigh_back")}
        />
        <Path
          d="M106.681 518.171h22.5s0-4.82 1-13.86 5.02-22.89 4.62-31.73c1.81-4.42 7.1-19.44 7.15-35.52.05-16.08-4.18-32.42-4.18-32.42h-31.01s1.36 13.46-.49 22.35c-3.36 16.19-1 35.75 1.21 46.79s-.8 44.38-.8 44.38v.01z"
          fill={isSelected("right_calf_back") ? "#F94E19" : "#FED9CD"}
          onClick={() => toggleSelection("right_calf_back")}
        />
        <Path
          d="M126.201 294.98c11.38.56 31.55-5.7 28.7-28.7-2.85-23-5.54-14.62-7.47-33.86-18-6.76-32.92-.7-45.29 11.59v40.69s6.09 9.41 24.06 10.28z"
          fill={isSelected("right_buttock_back") ? "#F94E19" : "#FED9CD"}
          onClick={() => toggleSelection("right_buttock_back")}
        />
        <Path
          d="M94.53 554.18c-10.28 1.28-19.72-6.54-22.85-6.85-3.12-.32-6.25-.3-8.68-1.98-2.43-1.68-7.68-2.23-7.7-4.11-.03-2.11 3.03-4.36 8.7-5.32 2.65-.45 5.86-4.77 7.68-6.64 2.74-2.81 3.44-11.1 3.44-11.1h22.5s1.71 7.38 0 11.34 3.471 10.21 2.861 16.76c-.61 6.55-5.94 7.92-5.94 7.92l-.01-.02zM97.61 518.171h-22.5s0-4.82-1-13.86-5.02-22.89-4.62-31.73c-1.81-4.42-7.1-19.44-7.15-35.52-.05-16.08 4.18-32.42 4.18-32.42h31.01s-1.36 13.46.49 22.35c3.361 16.19 1 35.75-1.21 46.79s.8 44.38.8 44.38v.01zM78.09 294.98c-11.38.56-31.55-5.7-28.7-28.7 2.85-23 5.54-14.62 7.47-33.86 18-6.76 32.92-.7 45.291 11.59v40.69s-6.09 9.41-24.06 10.28z"
          fill={isSelected("left_foot_back") ? "#FF99FF" : "#FCF"}
          onClick={() => toggleSelection("left_foot_back")}
        />
        <Path
          d="M97.61 518.171h-22.5s0-4.82-1-13.86-5.02-22.89-4.62-31.73c-1.81-4.42-7.1-19.44-7.15-35.52-.05-16.08 4.18-32.42 4.18-32.42h31.01s-1.36 13.46.49 22.35c3.361 16.19 1 35.75-1.21 46.79s.8 44.38.8 44.38v.01zM78.09 294.98c-11.38.56-31.55-5.7-28.7-28.7 2.85-23 5.54-14.62 7.47-33.86 18-6.76 32.92-.7 45.291 11.59v40.69s-6.09 9.41-24.06 10.28z"
          fill={isSelected("left_calf_back") ? "#FF99FF" : "#FCF"}
          onClick={() => toggleSelection("left_calf_back")}
        />
        <Path
          d="M78.09 294.98c-11.38.56-31.55-5.7-28.7-28.7 2.85-23 5.54-14.62 7.47-33.86 18-6.76 32.92-.7 45.291 11.59v40.69s-6.09 9.41-24.06 10.28z"
          fill={isSelected("left_buttock_back") ? "#FF99FF" : "#FCF"}
          onClick={() => toggleSelection("left_buttock_back")}
        />
        <Path
          d="M97.54 404.649H66.53s-7.36-17.01-4.1-36.57c-2.1-12.11-17.07-57.37-11.72-88.38 5.7 14.71 32.51 23.2 51.431 5 0 20.51-.79 28.29-2 42.64-1.09 13-1.54 33.77-.27 42.37 1.27 8.6 1.16 25.97-2.33 34.94z"
          fill={isSelected("left_thigh_back") ? "#FF99FF" : "#FCF"}
          onClick={() => toggleSelection("left_thigh_back")}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_3749_24592">
          <Path
            fill="#fff"
            transform="translate(.51)"
            d="M0 0H202.52V555.08H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
